import React, { useEffect } from 'react';
import 'react-phone-number-input/style.css';

import { GTagEvents, triggerGTag } from '@/lib/gTagManager';
import UserCompleteProfileFormManager from '@/components/shared/complete-profile/UserCompleteProfileFormManager';
import { BaseModalProps } from '@/features/modal/types';
import { ModalLayout } from '@/features/modal/modals/ModalLayout';

export const CompleteProfileModal = ({ closeModal }: BaseModalProps) => {
  useEffect(() => {
    triggerGTag(GTagEvents.complete_profile_modal_open);
  }, []);

  const handleCloseModal = () => {
    triggerGTag(GTagEvents.complete_profile_modal_close);
    closeModal();
  };

  const onSuccessHandler = () => {
    handleCloseModal();
  };

  return (
    <ModalLayout close={handleCloseModal} className="max-w-sm">
      <UserCompleteProfileFormManager onSuccess={onSuccessHandler} />
    </ModalLayout>
  );
};
